import { Widget } from 'src/app/core/models/core.models';
import { augmentObjectWithIconAndImage } from 'src/app/shared/utils/object-utils';

/**
 * Display augmentation for a fetched widget: the attached datasources and
 * dimensions are rendered as object chips, so each one needs its icon/image.
 * Purely client-side - nothing in the widget write payloads depends on it.
 */
export function augmentWidgetFields(widget: Widget): Widget {
  return {
    ...widget,
    datasources: widget.datasources?.map(augmentObjectWithIconAndImage) ?? [],
    dimensions_filter:
      widget.dimensions_filter?.map(augmentObjectWithIconAndImage) ?? [],
    dimensions_pivot:
      widget.dimensions_pivot?.map(augmentObjectWithIconAndImage) ?? [],
  };
}
